/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsBlockHeightFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsBlockHeightFormat = ClosedEnum<
  typeof GetApiV3MetricsBlockHeightFormat
>;

export type GetApiV3MetricsBlockHeightRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsBlockHeightFormat | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsBlockHeightFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsBlockHeightFormat
> = z.nativeEnum(GetApiV3MetricsBlockHeightFormat);

/** @internal */
export const GetApiV3MetricsBlockHeightFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsBlockHeightFormat
> = GetApiV3MetricsBlockHeightFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsBlockHeightFormat$ {
  /** @deprecated use `GetApiV3MetricsBlockHeightFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsBlockHeightFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsBlockHeightFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MetricsBlockHeightFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsBlockHeightRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsBlockHeightRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsBlockHeightFormat$inboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/** @internal */
export type GetApiV3MetricsBlockHeightRequest$Outbound = {
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsBlockHeightRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsBlockHeightRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsBlockHeightRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsBlockHeightFormat$outboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsBlockHeightRequest$ {
  /** @deprecated use `GetApiV3MetricsBlockHeightRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsBlockHeightRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsBlockHeightRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsBlockHeightRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsBlockHeightRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsBlockHeightRequest$Outbound;
}

export function getApiV3MetricsBlockHeightRequestToJSON(
  getApiV3MetricsBlockHeightRequest: GetApiV3MetricsBlockHeightRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsBlockHeightRequest$outboundSchema.parse(
      getApiV3MetricsBlockHeightRequest,
    ),
  );
}

export function getApiV3MetricsBlockHeightRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsBlockHeightRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3MetricsBlockHeightRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsBlockHeightRequest' from JSON`,
  );
}
